export const SENTRY_TAG_FEATURE = 'feature';
export const SENTRY_TAG_FEATURE_UPLOADER = 'uploader';

export const SENTRY_TAG_SYSTEM_DOMAIN_ID = 'system_domain_id';
